var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('p',[_vm._v("请扫描下方二维码，加入钉钉组织架构，体验速云产品")]),_c('img',{attrs:{"src":require("../assets/img/home/su.png"),"alt":""}})])}]

export { render, staticRenderFns }